import { ApiClientError } from '@/lib/http-core';
import { friendlyMessage } from './friendlyMessage';

/**
 * BE 검증 실패의 칸별 사유(error.details, 예 `{ albumTitle: "공백일 수 없습니다" }`)를 "앨범명: 공백일 수 없습니다"
 * 줄로 바꾼다. friendlyMessage 는 error.message("요청 검증 실패")만 보여 주고 details 를 버려, 운영자가 어느 칸이
 * 문제인지 알 수 없었다. 칸 이름은 화면 라벨로 바꾸고(labels), 모르는 칸은 키 그대로 둔다. 문자열 값만 쓴다.
 */
export const formatErrorDetails = (
  error: unknown,
  labels: Readonly<Record<string, string>> = {},
): string[] => {
  if (!(error instanceof ApiClientError) || !error.details) return [];
  return Object.entries(error.details)
    .filter((entry): entry is [string, string] => typeof entry[1] === 'string' && entry[1].trim() !== '')
    .map(([field, reason]) => `${labels[field] ?? field}: ${reason.trim()}`);
};

/** friendlyMessage + 칸별 사유. 사유가 없으면 friendlyMessage 와 같다. */
export const friendlyMessageWithDetails = (
  error: unknown,
  fallback: string,
  labels: Readonly<Record<string, string>> = {},
): string => {
  const details = formatErrorDetails(error, labels);
  const base = friendlyMessage(error, fallback);
  return details.length > 0 ? `${base} — ${details.join(', ')}` : base;
};
